import { type FormikProps, getIn } from 'formik'

export class FormikFieldErrors {
  formik: FormikProps<any>

  constructor (formik: FormikProps<any>) {
    this.formik = formik
  }

  fieldInError (fieldName: string): boolean {
    void this.formik.touched // I need to do this so that the "touched" node is loaded
    void this.formik.errors // I need to do this so that the "touched" node is loaded
    const error = getIn(this.formik.errors, fieldName)
    const touched = getIn(this.formik.touched, fieldName)
    return touched !== undefined && error !== undefined
  }

  getError (fieldName: string): string {
    void this.formik.touched // I need to do this so that the "touched" node is loaded
    void this.formik.errors
    const error = getIn(this.formik.errors, fieldName)
    const touched = getIn(this.formik.touched, fieldName)
    return (touched !== undefined && error !== undefined) ? error : ''
  }
}
